import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class PicklistApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.PICKLIST);
  }

  // picklist-shipment
  getShipmentsOfPicklist(picklistId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${picklistId}/shipments/?${queryString}`
      : `${this.getResourceUrl()}${picklistId}/shipments/`;

    return this.httpClient.get(url);
  }

  getShipmentDetailOfPicklist(picklistId, shipmentId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${picklistId}/shipments/${shipmentId}/`,
    );
  }

  splitPicklistShipment(picklistId, shipmentId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${picklistId}/shipments/${shipmentId}/split/`,
      {},
    );
  }

  // picklist
  getProductsOfPicklist(picklistId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${picklistId}/products/?${queryString}`
      : `${this.getResourceUrl()}${picklistId}/products/`;

    return this.httpClient.get(url);
  }

  getProductBatchesOfPicklist(picklistId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${picklistId}/product-batches/?${queryString}`
      : `${this.getResourceUrl()}${picklistId}/product-batches/`;

    return this.httpClient.get(url);
  }

  // picklist-picked
  getPickedShipment(picklistId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${picklistId}/picked/shipment/`,
    );
  }

  setShipmentStatusToPicked(picklistId, shipmentCode) {
    return this.httpClient.post(
      `${this.getResourceUrl()}${picklistId}/picked/shipment/`,
      { shipment_code: shipmentCode },
    );
  }

  setShipmentLineStatusToPicked(picklistId, barcode) {
    return this.httpClient.post(
      `${this.getResourceUrl()}${picklistId}/picked/shipment/line-picked/`,
      { barcode: barcode },
    );
  }

  setShipmentLineStatusToRejected(picklistId, data) {
    return this.httpClient.post(
      `${this.getResourceUrl()}${picklistId}/picked/shipment/line-rejected/`,
      data,
      { skipGlobal403: true },
    );
  }

  setPickedShipmentStatusToSidelined(picklistId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${picklistId}/picked/sidelined/`,
      {},
    );
  }

  // picklist-status
  picklistStatusToClosed(picklistId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${picklistId}/status/closed/`,
      {},
    );
  }

  picklistStatusToReceiving(picklistId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${picklistId}/status/receiving/`,
      {},
    );
  }
}

export default new PicklistApi();
